import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import s from './WorkTracker.module.scss';
import { taskShape } from './propTypes';
import { PlusIcon } from './icons';

const newId = () => Math.random().toString(16).slice(2, 10);

// The "add a step" box stays hidden until the + is pressed, so a task that
// has no checklist shows just the heading. It stays open between steps.
export default function Checklist({ task, onChange, onDirty }) {
  const [draft, setDraft] = useState('');
  const [adding, setAdding] = useState(false);
  const inputRef = useRef(null);
  useEffect(() => { if (onDirty) onDirty(draft.trim().length > 0); }, [onDirty, draft]);
  useEffect(() => { if (adding) inputRef.current?.focus(); }, [adding]);
  const steps = task.checklist || [];
  const add = () => {
    const text = draft.trim();
    if (!text) return;
    onChange([...steps, { id: newId(), text, done: false }]);
    setDraft('');
  };
  return (
    <div className={s.section}>
      <div className={s.labelRow}>
        <h3 className={s.sectionTitle} style={{ margin: 0 }}>Checklist</h3>
        <button
          type="button"
          className={s.iconEdit}
          aria-label="Add a checklist step"
          title="Add a checklist step"
          aria-expanded={adding}
          onClick={() => setAdding((a) => !a)}
        >
          <PlusIcon />
        </button>
      </div>
      {steps.length > 0 && (
        <ul className={s.stepList}>
          {steps.map((step) => (
            <li key={step.id} className={s.step}>
              <input
                type="checkbox"
                checked={!!step.done}
                aria-label={step.text}
                onChange={(e) => onChange(steps.map((x) => (x.id === step.id ? { ...x, done: e.target.checked } : x)))}
              />
              <span className={`${s.stepText} ${step.done ? s.stepDone : ''}`}>{step.text}</span>
              <button
                type="button"
                className={s.x}
                aria-label={`Remove step ${step.text}`}
                onClick={() => onChange(steps.filter((x) => x.id !== step.id))}
              >
                ×
              </button>
            </li>
          ))}
        </ul>
      )}
      {adding && (
      <div className={s.addRow}>
        <input
          ref={inputRef}
          className={s.input}
          value={draft}
          placeholder="Add a step"
          aria-label="New step"
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); add(); } }}
        />
        <button type="button" className={s.btn} onClick={add}>Add</button>
      </div>
      )}
    </div>
  );
}

Checklist.propTypes = {
  task: taskShape.isRequired,
  onChange: PropTypes.func.isRequired,
  onDirty: PropTypes.func,
};
Checklist.defaultProps = { onDirty: undefined };
